import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileTaxInformationPage.css';

const MobileTaxInformationPage = () => {
  const navigate = useNavigate();

  const goContact = () => navigate('/contact-us');

  return (
    <div className="mtx-page">
      <header className="mtx-header">
        <button type="button" className="mtx-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mtx-title">Tax Information</h1>
      </header>

      <div className="mtx-strip-wrap">
        <div className="mtx-strip" role="navigation" aria-label="Tax program links">
          <button type="button" className="mtx-strip-link" onClick={() => navigate('/membership-packages')}>
            Membership benefits
          </button>
          <button type="button" className="mtx-strip-link" onClick={() => navigate('/mobile/coupons-credit')}>
            Tax-exempt purchases
          </button>
          <button type="button" className="mtx-strip-link" onClick={goContact}>
            Exemption help
          </button>
        </div>
      </div>

      <section className="mtx-card">
        <h2>Alibaba.com tax exemption program</h2>
        <p>
          Learn how verified business buyers can apply for tax-exempt purchasing where available in your region.
        </p>
        <button type="button" className="mtx-action" onClick={() => navigate('/faq')}>
          View program details
        </button>
      </section>

      <section className="mtx-card">
        <h2>US sales tax exemption</h2>
        <p>
          If you purchase products for resale or production, submit tax information to be verified and place tax-exempt orders.
        </p>
        <button type="button" className="mtx-action" onClick={goContact}>
          Submit
        </button>
      </section>

      <section className="mtx-card">
        <h2>EU / NO / UK / CH or AU / NZ / SG / CL tax information submission</h2>
        <p>Add your VAT, GST, or regional tax IDs for verification before placing orders.</p>
        <button type="button" className="mtx-action" onClick={goContact}>
          Add tax information
        </button>
      </section>

      <section className="mtx-card">
        <h2>Canadian Provincial Sales Tax exemption</h2>
        <p>Submit PST or QST details for resale or production-related purchases.</p>
        <button type="button" className="mtx-action" onClick={goContact}>
          Add PST information
        </button>
      </section>
    </div>
  );
};

export default MobileTaxInformationPage;
